import React from 'react';
import { quickStats } from '../../data/salesContent';
export function StatsSection() {
  return <section className="border-y border-ink-line bg-ink-soft px-5 py-16 md:py-20" aria-label="Datos del sistema" data-id="element-228" data-mp="3ezj1c1qb3moq">
      <div className="mx-auto max-w-6xl" data-id="element-229" data-mp="3031pzai4a826">
        <ul className="grid grid-cols-2 gap-4 md:gap-6 lg:grid-cols-4" data-id="element-230" data-mp="304cu5bfh5htt">
          {quickStats.map(s => <li key={s.label} className="flex flex-col items-center rounded-2xl border border-gold/25 bg-ink px-4 py-8 text-center md:py-10" data-id="element-231" data-mp="3sqntkirchcp1">
              <span className="font-display text-6xl font-black leading-none text-gold md:text-7xl" data-id="element-232" data-mp="1jbbm1in0v82">{s.value}</span>
              <span className="mt-4 text-sm font-bold uppercase tracking-wider text-cream md:text-base" data-id="element-233" data-mp="3j0bakuz6hrl0">{s.label}</span>
            </li>)}
        </ul>
        <p className="mt-12 text-center font-display text-2xl font-black uppercase text-cream md:text-4xl" data-id="element-234" data-mp="fjm3n7voofut">
          Todo en un <span className="text-gold" data-id="element-235" data-mp="kbvz13fki84h">solo sistema.</span>
        </p>
      </div>
    </section>;
}